import { render } from "./TheGiaDinhVanHoa.vue?vue&type=template&id=3b91a758"
import script from "./TheGiaDinhVanHoa.vue?vue&type=script&lang=js"
export * from "./TheGiaDinhVanHoa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__